import React, { FC, useCallback } from 'react';
import { I18nextProvider, useTranslation } from 'react-i18next';
import { updateHeaderLanguage } from 'src/front/api/apiInstance';

import i18nConfig from 'src/front/common/i18n';

export enum Languages {
  Russian = 'ru',
  English = 'en',
}

type LanguageDispatch = (lng: Languages) => void;

export const I18nProvider: FC = ({ children }) => (
  <I18nextProvider i18n={i18nConfig}>{children}</I18nextProvider>
);

export const useLanguageState = (): string => {
  const { i18n } = useTranslation();

  return i18n.language;
};

export const useLanguageDispatch = (): LanguageDispatch => {
  const { i18n } = useTranslation();

  const changeLanguge = useCallback(
    (lng: Languages): void => {
      i18n.changeLanguage(lng, () => {
        updateHeaderLanguage(lng);
      });
    },
    [i18n]
  );

  return changeLanguge;
};
